

const GATEWAY_HOST_MAP = {
  test1: '//gateway.test.xdf.cn/magic-api',//'//capi.staff.xdf.cn/mock/925',
  // test1: '//10.201.240.178:8181',//'//capi.staff.xdf.cn/mock/925',
  test2: '//nzhaosh-wechatopenapi-test2.test.xdf.cn',
  test3: '//nzhaosh-wechatopenapi-test3.test.xdf.cn',
  test4: '//nzhaosh-wechatopenapi-test4.test.xdf.cn',
  test5: '//nzhaosh-wechatopenapi-test5.test.xdf.cn',
  test6: '//nzhaosh-wechatopenapi-test6.test.xdf.cn',
  prod: '//teach-assist-management.xdf.cn/magic-api',
};


export const GATEWAY_HOST = GATEWAY_HOST_MAP[process.env.VUE_APP_NODE_BUILD_ENV];
